<template>
  <div class="box">
    <banner :bannerH="$t('exhibitionSoftware.bannerTitle')" :bannerImg="bannerImg1"></banner>

    <scroll-animate>
      <div class="case_box">
        <div class="content w1200">
          <div class="cont active">
            <img class="bg" src="@/assets/img/platform/platform_gz3.png"/>
            <div class="info">
              <div class="title">
                <div class="logo"><img src="@/assets/img/logo.png"/></div>
                <h4>{{ $t('exhibitionSoftware.title') }}</h4>
              </div>
              <p>{{ $t('exhibitionSoftware.description') }}</p>
              <h5>{{ $t('exhibitionSoftware.mainAdvantages') }}</h5>
              <ul>
                <li>{{ $t('exhibitionSoftware.advantages.realTimeManagement') }}</li>
                <li>{{ $t('exhibitionSoftware.advantages.multiSystemSupport') }}</li>
                <li>{{ $t('exhibitionSoftware.advantages.communicationType') }}</li>
                <li>{{ $t('exhibitionSoftware.advantages.windowsSupport') }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </scroll-animate>

    <scroll-animate>
      <div class="system_service_introduced">
        <img src="@/assets/img/智能门控系统.png">
      </div>
    </scroll-animate>


  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import ScrollAnimate from "../../components/ScrollAnimate.vue";

export default {
  components: {ScrollAnimate, Banner},
  data() {
    return {
      bannerImg1: require("@/assets/img/banner-bg/bananer-mountain.png"),
    }
  },
  mounted() {
    // $(function() {
    //   $('.category ul li').click(function() {
    //     let i = $(this).index();
    //     $(this).addClass('active').siblings().removeClass('active');
    //     $('.content .cont').eq(i).addClass('active').siblings().removeClass('active');
    //   })
    // });
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/softwareCommonCss";
</style>
